import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../Button/Button';

import styles from './Welcome.module.scss';

type Props = {
  onCloseButtonClick?: () => void;
  onCountdownCompleted?: () => void;
  siteName?: string;
};

const Welcome: React.FC<Props> = ({ onCloseButtonClick, siteName }) => {
  const { t } = useTranslation('account');

  useEffect(() => {
    sessionStorage.removeItem('isSignInProgress');
  }, []);

  return (
    <div className={styles.welcome}>
      <h2>{t('checkout.welcome_title', { siteName })}</h2>
      <p>{t('checkout.welcome_description', { siteName })}</p>
      <Button variant="contained" color="primary" label={t('checkout.welcome_understood')} onClick={onCloseButtonClick} size="large" fullWidth />
    </div>
  );
};

export default Welcome;
